function isSSO() {
    return process.env.REACT_APP_SURVEY_METHOD === 'sso';
}

export default isSSO;
